<template>
<div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <BlockUI v-if="loader.busy">
        <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12 m-auto">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <h3 class="mb-0" v-if="isEdit()">แก้ไขข้อมูลขนส่ง</h3>
                                <h3 class="mb-0" v-else>เพิ่มข้อมูลขนส่ง</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <h6 class="heading-small text-muted mb-3" v-if="!isEdit()">เลือกระบบขนส่ง</h6>
                        <div class="row" v-if="isWho() == 'superadmin' || isWho() == 'shippop'">
                            <div class="col-md-12">
                                <b-form-group>
                                    <b-form-radio v-model="inputCourier.selectCourierType" checked value="1" :disabled="isEdit()">
                                        <h4>{{$THEME.webTitle}}<small> (ตรวจสอบราคาขนส่งมาจากระบบ {{$THEME.webTitle}})</small></h4>
                                    </b-form-radio>
                                    <b-form-radio v-model="inputCourier.selectCourierType" checked value="2" :disabled="isEdit() || isWho() == 'admin'">
                                        <h4>PreBarcode {{$THEME.webTitle}}<small> (ตรวจสอบราคาขนส่งมาจากระบบ {{$THEME.webTitle}} และใช้ระบบPrebarcode โดยไม่ต้องพิมใบปะหน้า)</small></h4>
                                    </b-form-radio>
                                    <b-form-radio v-model="inputCourier.selectCourierType" checked value="0" :disabled="isEdit()">
                                        <h4>ทั่วไป<small> (กำหนดค่าขนส่งเอง)</small></h4>
                                    </b-form-radio>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row" v-if="isWho() == 'admin' && !isEdit()">
                            <div class="col-md-12">
                                <b-form-group>
                                    <b-form-radio v-model="inputCourier.adminSelectCourierType" checked value="1">
                                        <h4>{{$THEME.webTitle}}<small> (เลือกขนส่งที่ {{$THEME.webTitle}} ให้ใช้บริการ)</small></h4>
                                    </b-form-radio>
                                    <b-form-radio v-model="inputCourier.adminSelectCourierType" value="0" checked>
                                        <h4>ทั่วไป<small> (กำหนดค่าขนส่งเอง)</small></h4>
                                    </b-form-radio>
                                </b-form-group>
                            </div>
                        </div>
                        <template>
                            <DetailsCourier
                                ref="detailsCourier"
                                :inputCourier="inputCourier"
                                :validateData="validateData"
                                :permission="permission"
                                :isEdit="isEdit()"
                                @selectCourierList="selectCourierList"
                                @checkCourierKeys="checkCourierKeys"
                                @handleLoader="handleLoader"

                            />
                                <!-- <div class="col-lg-4 mb-3">
                                    <b-form-group
                                    id="input-group-1"
                                    label="รูปภาพ"
                                    label-for="input-1"
                                    class="mb-0" >
                                    <b-form-file
                                    placeholder="Choose a file..."
                                    drop-placeholder="Drop file here...">
                                    </b-form-file>
                                    <div v-if="this.icon != ''">{{this.icon}}</div>
                                    </b-form-group>
                                </div> -->

                            <hr class="my-4" />
                            
                            <div class="excel-rate pb-2" v-if="['shippop', 'superadmin', 'admin'].includes(isWho()) && inputCourier.courierKey">
                                <button class="btn btn-primary btn-sm" @click="generateExcelRate()">Export</button>
                                <ImportRateExcel @onSuccess="onSelectRateExcel">
                                    <template v-slot:header>
                                        <button class="btn btn-primary btn-sm" :disabled="( checkUpdateForOneSuperadmin() || ($USER_LOGIN.get().isShippop && isEdit()) )">Import</button>
                                    </template>
                                </ImportRateExcel>
                            </div>
                        </template>

                        <b-card no-body class="table-rate">
                            <b-tabs card>
                                <b-tab :title="nameTab(zoneKey)" v-for="(rate , zoneKey ) in tableRate.courierRate" :key="zoneKey">
                                    <div class="row" v-if="isWho() != 'shippop'">
                                        <h6 class="heading-small text-muted mb-4">เลือกรูปแบบตารางราคา</h6>
                                        <h6 class="heading-small text-muted mb-4 pl-3">
                                            <input type="radio" class="pr-2" v-model="priceTableStyle" @change="generatePrice()" value="show_price"/><span class="p-1">แสดงราคาขาย</span>
                                            <input type="radio" class="pr-2" v-model="priceTableStyle" @change="generatePrice()" value="show_diff_price"/><span class="p-1">แสดงกำไรสาขา (ไม่รวมค่าบริการ)</span></h6>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card shadow">
                                                <div class="table-responsive">
                                                    <table class="table">
                                                        <thead>
                                                            <tr class="text-center">
                                                                <th>ลำดับ</th>
                                                                <th>น้ำหนัก(min-max)</th>
                                                                <th v-if="permission.table.dimension.show">ขนาดพัสดุ</th>
                                                                <!-- ต้นทุน cost -->
                                                                <th v-if="isWho() == 'superadmin' || isWho() == 'shippop' && !permission.isGen">
                                                                    ต้นทุน {{$THEME.webTitle}}
                                                                </th>
                                                                <th v-else-if="isWho() == 'superadmin' || isWho() == 'shippop' &&permission.isGen">ต้นทุนจริง</th>
                                                                <!-- xxxxxxxxxxxxxxxxxx -->

                                                                <!-- ราคาขายให้ร้านค้า price -->
                                                                <th v-if="isWho() == 'superadmin' || isWho() == 'shippop'">ต้นทุนร้านค้า</th>
                                                                <th v-if="isWho() == 'admin'">ต้นทุน</th>
                                                                <!-- xxxxxxxxxxxxxxxxxx -->
                                                                <th v-if="isWho() != 'shippop' && priceTableStyle === 'show_diff_price'">กำไรสาขา</th>
                                                                <th v-if="isWho() == 'shippop' || priceTableStyle === 'show_price'">ราคาขาย</th>
                                                                <th v-if="isWho() == 'admin'">ค่าบริการอื่นๆ</th>
                                                                
                                                                <th v-if="isWho() != 'superadmin'">ราคาขายสุทธิ</th>
                                                                
                                                                <th v-if="!checkUpdateForOneSuperadmin() || ( $USER_LOGIN.get().isShippop && !isEdit() )|| permission.isGen">การจัดการ</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item,index) in rate" :key="index+1" class="text-center" >
                                                                <td class="td-relative">
                                                                    <i class="fas fa-info-circle fa-sm text-blue error-icon" v-if="rateError[index]" v-b-tooltip :title="generateRateErrorMessage(rateError[index])"></i>{{ index+1 }}
                                                                </td>
                                                                <td>
                                                                    <div class="d-flex align-items-center">
                                                                        <input type="number" step="0.01" min="0.00" alternative class="form-control px-2" v-model="item.min" disabled />
                                                                        <label class="px-2">-</label>
                                                                        <input type="number" step="0.01" min="0.00" alternative class="form-control px-2" v-model="item.max" 
                                                                            @blur="autoUpdateRateMax(zoneKey , index)" @change="addNewRate(zoneKey , index )" :disabled="permission.table.max.disabled || ( isWho() == 'superadmin' && $THEME.manageDisable.weightSuperAdmin ) || ( $USER_LOGIN.get().isShippop && isEdit() ) || checkUpdateForOneSuperadmin()" />
                                                                        <!-- :disabled="(['admin','superadmin'].includes(isWho())) && !permission.isGen"  -->
                                                                    </div>
                                                                </td>
                                                                <td v-if="permission.table.dimension.show">
                                                                    <input type="text" alternative placeholder="ก+ย+ส" class="form-control" v-model="item.dimension" :disabled="permission.table.dimension.disabled || ( isWho() == 'superadmin' && $THEME.manageDisable.dimensionSuperAdmin ) || ( $USER_LOGIN.get().isShippop && isEdit() ) || checkUpdateForOneSuperadmin() " />
                                                                </td>
                                                                <td>
                                                                    <input v-if="isWho() == 'superadmin'|| isWho() == 'shippop'" type="number" step="0.1" min="0.00"  placeholder class="form-control" v-model="item.cost" :disabled="permission.table.rate.disabled || isWho() == 'superadmin' && $THEME.manageDisable.costSuperAdmin || ( $USER_LOGIN.get().isShippop && isEdit() ) || checkUpdateForOneSuperadmin()"/>
                                                                    <input v-if="isWho() == 'admin' && !permission.isGen" type="number" step="0.1" min="0.00"  placeholder class="form-control" v-model="item.rate" disabled />
                                                                    <input v-else-if="isWho() == 'admin' && permission.isGen" type="number" step="0.1" min="0.00"  placeholder class="form-control" v-model="item.cost" />
                                                                </td>
                                                                <td v-if="isWho() == 'superadmin' || isWho() == 'shippop'">
                                                                    <input type="number" v-on:keyup="generatePrice(zoneKey, index)"  step="0.01" min="0.00"  placeholder class="form-control" v-model="item.rate" :disabled="( $USER_LOGIN.get().isShippop && isEdit() ) || checkUpdateForOneSuperadmin()"/>
                                                                    <span v-if="item.rate && parseFloat(item.rate) < parseFloat(item.cost)" class="text-xs text-warning">ต้นทุนร้านค้าต่ำกว่าต้นทุน {{$THEME.webTitle}}</span>
                                                                </td>
                                                                <!-- ราคาขาย -->
                                                                <td v-if="isWho() != 'shippop' && priceTableStyle === 'show_diff_price'">
                                                                    <input type="number" v-on:keyup="generatePrice(zoneKey, index)" step="0.1" min="0.00"  placeholder class="form-control" v-model="item.diff_price" :disabled="checkUpdateForOneSuperadmin() || checkDisableUpdatePrice()" />
                                                                </td>
                                                                <td v-if="isWho() == 'shippop' || priceTableStyle === 'show_price'">
                                                                    <input type="number" v-on:keyup="generatePrice(zoneKey, index)" step="0.1" min="0.00"  placeholder class="form-control" v-model="item.fake_price" :disabled="( $USER_LOGIN.get().isShippop && isEdit() ) || checkUpdateForOneSuperadmin() || checkDisableUpdatePrice()"/>
                                                                    <span v-if="item.fake_price && parseFloat(item.fake_price) < parseFloat(item.rate)" class="text-xs text-warning">ราคาขายต่ำกว่าต้นทุน</span>
                                                                </td>
                                                                <td v-if="isWho() == 'admin'">
                                                                    <input type="number" v-on:keyup="generatePrice(zoneKey, index)"  step="0.1" min="0.00"  placeholder class="form-control" v-model="item.fee" />
                                                                </td>
                                                                <!-- ราคาขายสุทธิ -->
                                                                <td v-if="isWho() !== 'superadmin'">
                                                                    <input type="number" v-on:keyup="generatePrice(zoneKey, index)" step="0.1" min="0.00"  placeholder class="form-control" v-model="item.price" readonly/>
                                                                    <span v-if="item.price && parseFloat(item.price) < parseFloat(item.rate)" class="text-xs text-warning">ราคาขายสุทธิต่ำกว่าต้นทุน</span>
                                                                </td>
                                                                <td v-show="!checkUpdateForOneSuperadmin() || ( $USER_LOGIN.get().isShippop && !isEdit() ) || permission.isGen">
                                                                    <button type="button" class="btn btn-sm px-3 btn-danger" @click="deleteRate( zoneKey , index )" :disabled="rate.length < 2">ลบ</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <b-alert :show="$USER_LOGIN.get().isSuperadmin" variant="yellow-light" class="text-center">  
                                                    <h4 class="text-danger">กรณีถ้ามีร้านค้าใช้เรทราคานี้แล้ว ทาง Superadmin จะไม่สามารถแก้ไขเรทราคานี้ได้</h4>
                                                </b-alert>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </template>
                    <hr class="my-4" />
                    <div class="row justify-content-end">
                        <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                            <button type="button" class="btn btn-secondary btn-block btn-icon py-3" @click="reloadPage()">คืนค่า
                            </button>
                        </div>
                        <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                            <button 
                                :disabled="!auth0RoleUsage('transportedit')"
                                type="button" 
                                class="btn btn-success btn-block btn-icon py-3" 
                                @click="checkBtnConfirmData()"
                            >ยืนยัน</button>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { createRateExcel }  from '@/helpers/excelGenerator'
import ImportRateExcel  from '@/components/custom/ImportRateExcel'
import CourierRules from '@/constants/CourierRules'
import { courierDetail as _COURIERS_ } from '@/config/courierCodes'
import configPOPTheme from '@/config/POPTheme'
import moment from 'moment'
import DetailsCourier  from '@/components/custom/transport/DetailsCourier'
import { auth0RoleUsage } from "@/helpers/auth0"
import Courier from '@/courier/Courier'
import { debounce } from "debounce"

const API_URL = process.env.VUE_APP_API;
const COURIER = new Courier()

export default {
    data() {

        return {
            loader: {
                busy: false,
            },
            permission: {
                table: {
                    min: {
                        disabled: false
                    },
                    max: {
                        disabled: false
                    },
                    dimension: {
                        show: false,
                        disabled: false
                    },
                    cost: {
                        show: false,
                        disabled: false
                    },
                    rate: {
                        show: false,
                        disabled: false
                    }
                },
                userLogin: "",
                isGen: false,
                samePage: false
            },
            rateError: {},
            inputCourier: {
                btnTitle: "",
                descriptionCouier: "",
                isEditRate: true,
                courierName: "",
                courierKey: this.isWho() === 'superadmin'?'SPGEN':'GEN',
                selectCourier: "",
                effective_date: (['shippop','superadmin','admin'].includes(this.isWho()))?moment().format('YYYY-MM-DDTHH:mm'):'',
                selectCourierType: this.isWho() ==='superadmin'?0:1,
                adminSelectCourierType: 1,
                prebarcode: 0,
                uploadPic: null,
                nameOfPic: "",
                refCode:"",
                rateCode:"",
                createdAt: '',
                updatedAt: '',
            },
            courierCheck: {
                shippopCourierKeys: CourierRules.shippopCourierKeys, 
                extraCouriers: CourierRules.extraCouriers,
                dimension: CourierRules.dimensionCouriers
            },
            // courierList: [],
            tableRate: {
                courierRate: this.defaultCourierRate()
            },
            priceTableStyle: this.isWho() == 'shippop' ?'show_price':(configPOPTheme.priceTableStyle || 'show_price'),
            validateData: {
                submitted: false,
                btnComfirm: false,
                checkInput: {
                    courierKey: null
                }
            },
            auth0RoleUsage:auth0RoleUsage,
            filterZone: {}
        }
    },
    beforeCreate() {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
    },
    mounted() {
        if (this.isEdit() && (this.isWho() == 'superadmin' || this.isWho() == 'shippop')) {
            this.superadminGetCourierForUpdate();
        } else if (!this.isEdit() && this.isWho() == 'admin') {
            this.$refs.detailsCourier.adminGetDefaultCouriers()
        } else if (this.isEdit() && this.isWho() == 'admin') {
            this.adminGetCourierForUpdate();
        } else if (this.isWho() == 'superadmin' && ! this.isEdit()) {
            this.initSuperadmin()
        }
        console.log('tableRate: ', this.tableRate)
    },
    components:{
        ImportRateExcel,
        DetailsCourier
    },
    methods: {
        initSuperadmin() {
            this.inputCourier.effective_date = moment().set({
                hour:0,minute:0
            }).format('YYYY-MM-DDTHH:mm')
        },
        columnText(field) {
            switch (field) {
                case 'min':
                    return 'น้ำหนัก (MIN)';
                case 'max':
                    return 'น้ำหนัก (MAX)';
                case 'dimension':
                    return 'ขนาดพัสดุ ก+ย+ส';
                case 'cost':
                    return `ต้นทุน ${this.$THEME.webTitle}`;
                case 'rate':
                    return 'ต้นทุนร้านค้า';
                case 'price':
                    return 'ราคาขายสุทธิ';
                case 'fake_price':
                    return 'ราคาขาย';
                case 'fee':
                    return 'ค่าบริการอื่นๆ';
            }
        },
        generateRateErrorMessage(errorArr) {
            if(errorArr) {
                let errorText = 'กรุณาตรวจสอบข้อมูลใน Excel เนื่องจากคุณไม่สามารถแก้ไขข้อมูล '
                
                errorArr.forEach((field, key) => {
                    errorText += (key>0?', ':'') + this.columnText(field) 
                })
                    
                return errorText + ' โดยระบบจะเลือกใช้ข้อมูลจากเดิมในระบบ'
            }
        },
        getMaxRowRates() {
            let max = 0;
            Object.keys(this.tableRate.courierRate).forEach((zoneKey)=> {
                const numRateOfZone = this.tableRate.courierRate[zoneKey].length
                if (numRateOfZone > max) {
                    max= numRateOfZone
                }
            })
            return max;
        },
        genMergeZone(numOfColumn) {
            let merges = [];
            Object.keys(this.tableRate.courierRate).forEach((zone, zoneIndex) => {
                merges.push({
                    s: {
                        r: 0, 
                        c: 0 + (zoneIndex*numOfColumn)
                    }, 
                    e: {
                        r: 0, 
                        c: (numOfColumn-1)+(zoneIndex*numOfColumn)
                    }
                })
            });
            return merges
        },
        initialRateExcel() {
            const hasDimension = this.checkCourierDimension()
            const fieldMapping = [
                    'min','max'
                ]
            let editableFields = []
            const columnZone = ['น้ำหนัก (MIN)', 'น้ำหนัก (MAX)']
            if (hasDimension) {
                columnZone.push('ขนาดพัสดุ ก+ย+ส')
                fieldMapping.push('dimension')
            }
            if (['shippop', 'superadmin'].includes(this.isWho())) {
                fieldMapping.push('cost')
                columnZone.push(`ต้นทุน ${this.$THEME.webTitle}`)

                if(this.isWho() == 'shippop' || !this.$THEME.manageDisable.weightSuperAdmin){
                    editableFields = [
                        'min',
                        'max',
                    ]
                }

                if (this.isWho() == 'shippop' && hasDimension || !this.$THEME.manageDisable.dimensionSuperAdmin && hasDimension ) {
                    editableFields.push('dimension')
                }

                if(this.isWho() == 'shippop' || !this.$THEME.manageDisable.costSuperAdmin){
                    editableFields.push('cost')
                }

                editableFields.push('rate')
                editableFields.push('price')
            }
            fieldMapping.push('rate')
            columnZone.push('ต้นทุนร้าน')
            if (['admin'].includes(this.isWho())) {
                fieldMapping.push('fake_price')
                columnZone.push('ราคาขาย')
                fieldMapping.push('fee')
                columnZone.push('ค่าบริการอื่นๆ')
                if (CourierRules[this.inputCourier.courierKey] && CourierRules[this.inputCourier.courierKey].lockPrice) {
                    editableFields = [
                        'fee'
                    ]
                } else {
                    editableFields = [
                        'fake_price',
                        'fee'
                    ]
                }
                
                if (this.permission.isGen) {
                    editableFields.push('min')
                    editableFields.push('max')
                    editableFields.push('dimension')
                    editableFields.push('rate')
                }
            } else {
                columnZone.push('ราคาขาย')
                fieldMapping.push('price')
            }
            
            return {
                columns: columnZone, 
                fields: fieldMapping, 
                editable_fields: editableFields
            }
        },
        onSelectRateExcel(excelResponse) {
            if (excelResponse.status) {
                const data = excelResponse.data
                const rateFormat = this.initialRateExcel()
                const fieldMapping = rateFormat.fields
                const editableFields = rateFormat.editable_fields
                const columnZone = rateFormat.columns
                const useDefaultZone = (data[2].length<=7 && !CourierRules[this.inputCourier.courierKey].useZoneIndex)?true:false // ใช้กับขนส่งที่มี zone เดียว type เป็น null นะ
                this.rateError = {}
                let zoneIndex = 0;
                for (let key_zone in this.tableRate.courierRate) {
                    data.forEach((excelRate, excelRateIndex) => {
                        if (excelRateIndex > 1) {
                            for (let i = 0; i<columnZone.length; i++) {
                                if (
                                    (this.tableRate.courierRate[key_zone][excelRateIndex-2] && this.tableRate.courierRate[key_zone][excelRateIndex-2][fieldMapping[i]]) || 
                                    excelRate[i + zoneIndex*columnZone.length]
                                ) {
                                    if (!this.tableRate.courierRate[key_zone][excelRateIndex-2]) {
                                        this.$set(this.tableRate.courierRate[key_zone], [excelRateIndex-2], {})
                                    }
                                    if (editableFields.includes(fieldMapping[i])) {
                                        if (fieldMapping[i] === 'min' && !(excelRateIndex-2) && !((i + zoneIndex*columnZone.length)%columnZone.length)) {
                                            excelRate[i + zoneIndex*columnZone.length] = 1
                                        }
                                        this.$set(this.tableRate.courierRate[key_zone][excelRateIndex-2], fieldMapping[i], excelRate[i + zoneIndex*columnZone.length])
                                    } else if (excelRate[i + zoneIndex*columnZone.length] != this.tableRate.courierRate[key_zone][excelRateIndex-2][fieldMapping[i]]) {
                                        if (!this.rateError[excelRateIndex-2]) {
                                            this.rateError[excelRateIndex-2] = []
                                        }
                                        this.rateError[excelRateIndex-2].push(fieldMapping[i])
                                    }
                                    if (fieldMapping[i] == 'price') {
                                        this.$set(this.tableRate.courierRate[key_zone][excelRateIndex-2], 'fake_price', parseFloat(excelRate[i + zoneIndex*columnZone.length]).toFixed(2))
                                    }
                                    if (fieldMapping[i] == 'fake_price') {
                                        if (editableFields.includes(['fake_price'])) {
                                            this.$set(this.tableRate.courierRate[key_zone][excelRateIndex-2], 'price', parseFloat(excelRate[i + zoneIndex*columnZone.length]) + parseFloat(excelRate[i + zoneIndex*columnZone.length + 1]))
                                        } else {
                                            // disable import price replace with rate in courier_rate
                                            this.$set(this.tableRate.courierRate[key_zone][excelRateIndex-2], 'price', this.tableRate.courierRate[key_zone][excelRateIndex-2].fake_price + parseFloat(excelRate[i + zoneIndex*columnZone.length + 1]))
                                        }
                                        
                                    }
                                    
                                    this.$set(this.tableRate.courierRate[key_zone][excelRateIndex-2], 'type', useDefaultZone?null:zoneIndex+1)
                                }

                            }
                        }
                    })
                    zoneIndex++;
                }                
            }
        },
        generateExcelRate() {
            const rateExcel = this.initialRateExcel()
            const hasDimension = this.checkCourierDimension()
            let zoneRow = [];
            let headerRow = [];
            let editColumn = rateExcel.columns

            let rateRows = [];
            const maxRateRow = this.getMaxRowRates()
            for (let key in this.tableRate.courierRate) {
                zoneRow.push(this.nameTab(key))
                zoneRow.push(null)
                zoneRow.push(null)
                zoneRow.push(null)
                if (['shippop', 'superadmin'].includes(this.isWho())) {
                    // shippop has permission to edit cost 
                    // superadmin can read cost
                    zoneRow.push(null)
                }
                if (this.isWho() === 'admin') { // add new column fee
                    zoneRow.push(null)
                }
                if (hasDimension) 
                    zoneRow.push(null)
                editColumn.forEach((col) => {
                    headerRow.push(col)
                })
                const zoneRowCount = this.tableRate.courierRate[key].length
                this.tableRate.courierRate[key].forEach((rate, rateRowIndex) => {
                    if (!rateRows[rateRowIndex]) {
                        rateRows[rateRowIndex] = []
                    }
                    rateRows[rateRowIndex].push(rate.min || '')
                    rateRows[rateRowIndex].push(rate.max || '')
                    if (hasDimension)
                        rateRows[rateRowIndex].push(rate.dimension || '')
                    if (['shippop', 'superadmin'].includes(this.isWho())) {
                        rateRows[rateRowIndex].push(rate.cost || '')
                    }
                    rateRows[rateRowIndex].push(rate.rate || '')
                    if (this.isWho() === 'admin') {
                        rateRows[rateRowIndex].push(rate.fake_price || '')
                        rateRows[rateRowIndex].push(rate.fee || '')
                    } else {
                        rateRows[rateRowIndex].push(rate.price || '')
                    }
                    
                })
                
                if (zoneRowCount < maxRateRow) {
                // fill empty rate
                    for(let i=zoneRowCount; i <maxRateRow; i++) {
                        if (!rateRows[i]) {
                            rateRows[i] = []
                        }
                        rateRows[i].push('')
                        rateRows[i].push('')
                        rateRows[i].push('')
                        rateRows[i].push('')
                        if (['shippop', 'superadmin'].includes(this.isWho())) {
                            rateRows[i].push('')
                        }
                        if (['admin'].includes(this.isWho())) {
                            rateRows[i].push('') // push empty fee
                        }
                        if (hasDimension)
                            rateRows[i].push('')
                    }
                }
                
            }
            const filename = "rate_" + this.inputCourier.courierKey +'_'+ moment().format('YYYY-MM-DD_HH-mm-ss') + ".xlsx";
            const merges = this.genMergeZone(editColumn.length)
            createRateExcel({
                file_name: filename, 
                merges: merges,
                data: rateRows,
                headers: [
                    zoneRow, 
                    headerRow
                ] 
            })
        },
        nameTab(key) {
            console.log('key is : ', key)
            // console.log('this.inputCourier: ', this.inputCourier)
            if ( ['SCGC', 'SCGF'].includes(this.inputCourier.courierKey) ) {
                if (key == 'BKK') {
                    return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด'
                } else if (key == 'UPC') {
                    return 'ต้นทาง: ต่างจังหวัด - ปลายทาง: ต่างจังหวัด'
                } else if (key == 'SAMEPV') {
                    return 'ภายในจังหวัดเดียวกัน'
                }
            } else if (this.inputCourier.courierKey == 'SCG') {
                if (key == 'BKK') {
                    return 'ต้นทางและปลายทางอยู่ภาคเดียวกัน'
                } else if (key == 'UPC') {
                    return 'ต้นทางและปลายทางอยู่คนละภาค'
                }
            } else if (this.inputCourier.courierKey == 'FLEB') {
                if (key == 'BKK_TO_BKK')
                    return 'ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล'
                if (key == 'BKK_TO_UPC')
                    return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด'
                if (key == 'UPC_WITH_SAME_PROVINCE')
                    return 'ต้นทางและปลายทาง: ต่างจังหวัด (ภายในจังหวัดเดียวกัน)'
                if (key == 'UPC_TO_UPC')
                    return 'ต้นทางและปลายทาง: ต่างจังหวัด'
                if (key == 'UPC_TO_BKK')
                    return 'ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
            } else if (['FLE', 'FLEF', 'FLEWP'].includes(this.inputCourier.courierKey)) {
                if (this.inputCourier.courierKey == 'FLE' && 
                (new Date(this.inputCourier.effective_date) >= new Date('2022-03-16 00:00:00') 
                    && new Date(this.inputCourier.effective_date) < new Date('2022-03-20 00:00:00')
                ) ||
                new Date(this.inputCourier.effective_date) >= new Date("2022-03-23 00:00:00")
            ) {
                    if (key == 'BKK_TO_BKK') {
                        return 'ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'BKK_TO_N_NE_S_C') {
                        return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง'
                    } else if (key == 'N_NE_S_C_TO_BKK') {
                        return 'ต้นทาง: เหนือ, อีสาน, ใต้, กลาง - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'N_TO_N_NE_S_C') {
                        return 'ต้นทาง: เหนือ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง'
                    } else if (key == 'NE_TO_N_NE_S_C') {
                        return 'ต้นทาง: อีสาน - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง'
                    } else if (key == 'S_TO_N_NE_S_C') {
                        return 'ต้นทาง: ใต้ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง'
                    } else if (key == 'C_TO_N_NE_S_C') {
                        return 'ต้นทาง: กลาง - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง'
                    } else if (key == 'SAME_N_TO_N_NE_S_C') {
                        return 'ต้นทาง - ปลายทาง: ภายในจังหวัด (เหนือ)'
                    } else if (key == 'SAME_NE_TO_N_NE_S_C') {
                        return 'ต้นทาง - ปลายทาง: ภายในจังหวัด (อีสาน)'
                    } else if (key == 'SAME_S_TO_N_NE_S_C') {
                        return 'ต้นทาง - ปลายทาง: ภายในจังหวัด (ใต้)'
                    } else if (key == 'SAME_C_TO_N_NE_S_C') {
                        return 'ต้นทาง - ปลายทาง: ภายในจังหวัด (กลาง)'
                    }
                } else {
                    if (key == 'same_N_NE_S') {
                        return 'ต้นทางและปลายทาง: เป็นจังหวัดเดียวกัน (ยกเว้นภาคกลาง, กรุงเทพฯ/ปริมณฑล)'
                    } else if (key == 'to_BKK') {
                        return 'ต้นทาง: เหนือ, อีสาน,ใต้ ปลายทาง กทม/ปริมณฑล (ยกเว้นภาคกลาง)'
                    } else if (key == 'N') {
                        return 'ต้นทาง: ภาคเหนือ - ปลายทาง: ทั่วประเทศ (ยกเว้นกรุงเทพฯ/ปริมณฑล)'
                    } else if (key == 'NE') {
                        return 'ต้นทาง: ภาคอีสาน - ปลายทาง: ทั่วประเทศ (ยกเว้นกรุงเทพฯ/ปริมณฑล)    '
                    } else if (key == 'S') {
                        return 'ต้นทาง: ภาคใต้ - ปลายทาง: ทั่วประเทศ (ยกเว้นกรุงเทพฯ/ปริมณฑล)'
                    } else if (key == 'same_BKK') {
                        return 'ต้นทางและปลายทางภายในจังหวัด กรุงเทพฯ/ปริมณฑล '
                    } else if (key == 'from_BKK_C_to_no_BKK') {
                        return 'ต้นทาง: ภาคกลาง, กรุงเทพฯ/ปริมณฑล- ปลายทาง: ทั่วประเทศ'
                    } else if (key == 'same_C') {
                        return 'ต้นทางและปลายทาง: ภายในจังหวัดเดียวกันภาคกลาง (ยกเว้น กรุงเทพฯ/ปริมณฑล)'
                    } else if (key == 'C_to_BKK') {
                        return 'ต้นทาง: ภาคกลาง(ยกเว้นกรุงเทพฯ/ปริมณฑล) - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    }
                }
            } else if ( ['TRUE', 'EMSXP'].includes(this.inputCourier.courierKey) ) {
                if (key == 'BKK') {
                    return 'ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                } else if (key == 'UPC') {
                    return 'ปลายทาง: ต่างจังหวัด'
                }
            } else if ( ['SPXP'].includes(this.inputCourier.courierKey) ) {
                if (new Date(this.inputCourier.effective_date) >= new Date('2022-11-01 00:00:00')) {
                    if (key == 'BKK_TO_BKK') {
                        return 'ต้นทาง - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'BKK_TO_UPC') {
                        return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด'
                    } else if (key == 'UPC_TO_BKK') {
                        return 'ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'UPC_TO_UPC') {
                        return 'ต้นทาง - ปลายทาง: ต่างจังหวัด'
                    }
                } else {
                    if (key == 'BKK') {
                        return 'ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'UPC') {
                        return 'ปลายทาง: ต่างจังหวัด'
                    }
                }
            } else if (this.inputCourier.courierKey == 'BEST') {
                if (new Date(this.inputCourier.effective_date) >= new Date('2023-12-15 00:00:00')) {
                    if (key === 'GBKK_GBKK') {
                        return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key === 'GBKK_C-N-NE') {
                        return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ภาคกลาง/เหนือ/อีสาน'
                    } else if (key === 'GBKK_S') {
                        return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ภาคใต้'
                    } else if (key === 'C-N-NE_GBKK') {
                        return 'ต้นทาง: ภาคกลาง/เหนือ/อีสาน - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key === 'C-N-NE_S') {
                        return 'ต้นทาง: ภาคกลาง/เหนือ/อีสาน - ปลายทาง: ภาคใต้'
                    } else if (key === 'C-N-NE_C-N-NE') {
                        return 'ต้นทาง: ภาคกลาง/เหนือ/อีสาน - ปลายทาง: ภาคกลาง/เหนือ/อีสาน'
                    } else if (key === 'S_GBKK') {
                        return 'ต้นทาง: ภาคใต้ - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key === 'S_C-N-NE') {
                        return 'ต้นทาง: ภาคใต้ - ปลายทาง: ภาคกลาง/เหนือ/อีสาน'
                    } else if (key === 'S_S') {
                        return 'ต้นทาง: ภาคใต้ - ปลายทาง: ภาคใต้'
                    }
                } else if (new Date(this.inputCourier.effective_date) >= new Date('2022-01-13 00:00:00')) {
                    if (key == 'BKK_TO_BKK') {
                        return 'ส่งภายใน: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'BKK_TO_UPC') {
                        return 'ต้นทาง:  กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด'
                    } else if (key == 'UPC_TO_BKK') {
                        return 'ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'UPC_TO_UPC') {
                        return 'ต้นทาง: ต่างจังหวัด - ปลายทาง: ต่างจังหวัด'
                    }
                } else {
                    if (key == 'BKK') {
                        return 'ส่งภายใน: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'C') {
                        return 'ต้นทาง:  กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด'
                    } else if (key == 'N') {
                        return 'ส่งภายในภาคเดียวกัน'
                    } else if (key == 'NE') {
                        return 'ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                    } else if (key == 'S') {
                        return 'ต้นทาง: ต่างภาค - ปลายทาง: ต่างภาค'
                    } else if (key == 'SAME') {
                        return 'ภายในจังหวัดเดียวกัน'
                    } else if (key == 'SAME_C') {
                        return 'ภายในจังหวัดเดียวกัน (ภาคกลาง)'
                    } else if (key == 'W') {
                        return 'ต่างภาค'
                    }
                }
            } else if ( ['CJLX', 'NJV'].includes(this.inputCourier.courierKey) ) {
                if (key == 'BKK') {
                    return 'กรุงเทพฯ/ปริมณฑล'
                } else if (key == 'UPC') {
                    return 'ต่างจังหวัด'
                }
            } else if (this.inputCourier.courierKey == 'BEE') {
                if (key == 'BKK') {
                    return 'กรุงเทพฯ'
                }
            } else if (this.inputCourier.courierKey == 'TPSD') {
                if (key == 'DEFAULT') {
                    return 'ทั่วไป'
                }
            } else if (['XPSO','XPSD'].includes(this.inputCourier.courierKey)) {
                if (key == 'GBKK_TO_GBKK') {
                    return 'ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }
            } else if (
                this.inputCourier.effective_date && 
                new Date(this.inputCourier.effective_date) >= new Date('2023-01-01 00:00:00') &&
                ['MSE', 'MSEC', 'MSEF', 'SPE', 'SPEC'].includes(this.inputCourier.courierKey) 
            ) {
                if (key == 'BKK_GBKK_TO_BKK') {
                    return 'ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ'
                } else if (key == 'BKK_GBKK_TO_GBKK') {
                    return 'ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล'
                }
            } else if (
                ['MSE', 'MSEC', 'SPE', 'SPEC'].includes(this.inputCourier.courierKey)
            ) {
                if (key == 'BKK_GBKK_TO_BKK') {
                    return 'ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ'
                } else if (key == 'BKK_GBKK_TO_GBKK') {
                    return 'ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล (นนทบุรี, ปทุมธานี, สมุทรปราการ นครปฐม และสมุทรสาคร)'
                } else if (key == 'BKK_GBKK_TO_UPC') {
                    return 'ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง:	ต่างจังหวัด (ชลบุรี, ราชบุรี, เพชรบุรี, หัวหิน, สมุทรสงคราม, นครราชสีมา)'
                } else if (key == 'CBI') {
                    return 'ต้นทาง:	ชลบุรี ปลายทาง:	ภายในจังหวัด'
                } else if (key == 'CBI_TO_BKK_GBKK') {
                    return 'ต้นทาง:	ชลบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล'
                } else if (key == 'SAME_PBI_HUAHIN_SKM_RBR') {
                    return 'ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	ภายในจังหวัด'
                } else if (key == 'NEAR_IN_PBI_HUAHIN_SKM_RBR') {
                    return 'ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	จังหวัดใกล้เคียง'
                } else if (key == 'PBI_HUAHIN_SKM_RBR_TO_BKK_GBKK') {
                    return 'ต้นทาง:	เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล'
                } else if (key == 'SAME_KKN_NMA') {
                    return 'ต้นทาง:	ขอนแก่น, นครศรีธรรมราช ปลายทาง:	ภายในจังหวัด'
                } else if (key == 'NRT') {
                    return 'ต้นทาง:	นครราชสีมา ปลายทาง:	ภายในจังหวัด';
                } else if (key == 'NRT_TO_BKK_GBKK') {
                    return 'ต้นทาง: นครราชสีมา ปลายทาง:	กรุงเทพฯ - ปริมณฑล'
                }
            } else if ( this.inputCourier.courierKey === _COURIERS_.DHL.key ) {
                if( key == 'BKK' ){
                    return 'ปลายทาง: กทม / ปริมณฑล'
                }else if( key == 'C' ){
                    return 'ปลายทาง: กลาง / ตะวันออก'
                }else{
                    return 'ปลายทาง: เหนือ/อีสาน/ใต้'
                }
            } else if (['KRYS', 'KRYQ'].includes(this.inputCourier.courierKey) && 
                this.inputCourier.effective_date && 
                new Date(this.inputCourier.effective_date).getTime() >= new Date('2023-09-05 00:00:00').getTime()
            ) {
                // force update courie rules 
                let indexKerry = CourierRules.dimensionCouriers.indexOf('KRYS');
                if (indexKerry !== -1) {
                    this.courierCheck.dimension = CourierRules.dimensionCouriers.splice(indexKerry, 1);
                }
                let indexQuick = CourierRules.dimensionCouriers.indexOf('KRYQ');
                if (indexQuick !== -1) {
                    this.courierCheck.dimension = CourierRules.dimensionCouriers.splice(indexQuick, 1);
                }
                if ( key == 'SAME_PROVINCE' ) {
                    return 'ภายในจังหวัดเดียวกัน';
                } else if ( key == 'WITHIN_1200KM') {
                    return 'ไม่เกิน 1200 กม.';
                } else if ( key == 'MORE_THAN_1200KM' ) {
                    return 'มากกว่า 1200 กม.';
                }
            } else if (this.inputCourier.courierKey == 'KRYS') {
                console.log('old zone ', this.inputCourier.effective_date)
                if (key == 'BKK_TO_BKK') {
                    return 'ต้นทาง: กรุงเทพ/ปริมณฑล ปลายทาง: ภายในภาคเดียวกัน'
                }else if ( key == 'BKK_TO_UPC' ){
                    return 'ต้นทาง: กรุงเทพ/ปริมณฑล ปลายทาง: ข้ามภาค'
                }else if ( key == 'UPC23_SAME_PROVINCE' ){
                    return 'ต้นทาง: 23 จังหวัด ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if ( key == 'UPC23_SAME_UPC23' ){
                    return 'ต้นทาง: 23 จังหวัด ปลายทาง: ภายในภาคเดียวกัน'
                }else if ( key == 'UPC23_TO_UPC' ){
                    return 'ต้นทาง: 23 จังหวัด ปลายทาง: ข้ามภาค'
                }else if ( key == 'UPC50_SAME_PROVINCE' ){
                    return 'ต้นทาง: 50 จังหวัด ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if ( key == 'UPC50_SAME_UPC50' ){
                    return 'ต้นทาง: 50 จังหวัด ปลายทาง: ภายในภาคเดียวกัน'
                }else{
                    return 'ต้นทาง: 50 จังหวัด ปลายทาง: ข้ามภาค'
                }
            } else if (['KRYQ'].includes(this.inputCourier.courierKey)){
                if( key == 'BKKG_TO_BKKG' ){
                    return 'ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }else if ( key == 'BKKG_TO_UPC' ){
                    return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล ปลายทาง: ทุกภาค'
                }else if ( key == 'C_E_TO_BKKG' ){
                    return 'ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }else if ( key == 'C_E_TO_ALL' ){
                    return 'ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: ทุกภาค'
                }else if (  key == 'C_E_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if (  key == 'N_NE_S_TO_BKKG' ){
                    return 'ต้นทาง: ภาคเหนือ/ตะวันออกเฉียงเหนือ/ใต้ ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }else if (  key == 'N_TO_ALL' ){
                    return 'ต้นทาง: ภาคเหนือ ปลายทาง: ทุกภาค'
                }else if ( key == 'NE_TO_ALL' ){
                    return 'ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ทุกภาค'
                }else if ( key == 'S_TO_ALL' ){
                    return 'ต้นทาง: ภาคใต้ ปลายทาง: ทุกภาค'
                }else if ( key == 'N_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if ( key == 'NE_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if (  key == 'S_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคใต้ ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else{
                    return 'ทั่วไป'
                }
            } else if (['ORNG'].includes(this.inputCourier.courierKey)){
                if( key == 'BKKG_TO_BKKG' ){
                    return 'ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }else if ( key == 'BKKG_TO_UPC' ){
                    return 'ต้นทาง: กรุงเทพฯ/ปริมณฑล ปลายทาง: ทุกภาค'
                }else if ( key == 'C_E_W_TO_BKKG' ){
                    return 'ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }else if ( key == 'C_E_W_TO_ALL' ){
                    return 'ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: ทุกภาค'
                }else if (  key == 'C_E_W_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if (  key == 'N_NE_S_TO_BKKG' ){
                    return 'ต้นทาง: ภาคเหนือ/ตะวันออกเฉียงเหนือ/ใต้ ปลายทาง: กรุงเทพฯ/ปริมณฑล'
                }else if (  key == 'N_TO_ALL' ){
                    return 'ต้นทาง: ภาคเหนือ ปลายทาง: ทุกภาค'
                }else if ( key == 'NE_TO_ALL' ){
                    return 'ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ทุกภาค'
                }else if ( key == 'S_TO_ALL' ){
                    return 'ต้นทาง: ภาคใต้ ปลายทาง: ทุกภาค'
                }else if ( key == 'N_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if ( key == 'NE_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else if (  key == 'S_SAME_PROVINCE' ){
                    return 'ต้นทาง: ภาคใต้ ปลายทาง: ภายในจังหวัดเดียวกัน'
                }else{
                    return 'ทั่วไป'
                }
            } if (this.inputCourier.courierKey == 'JNT') {
                const text = COURIER.setCourier(this.inputCourier.courierKey).mapAvaliableZoneName(key)

                if (!text) {
                    return 'ทั่วไป'
                }
            
                return text
            } else {
                if (key == 'Default') {
                    return 'ทั่วไป'
                }
            }
        },
        generatePrice(zoneKey, index) {
            if (zoneKey && index >= 0) {
                let item = this.tableRate.courierRate[zoneKey][index]
                this.$set(item, 'price', parseFloat(item.price || 0).toFixed(2))
                this.$set(item, 'rate', parseFloat(item.rate || 0).toFixed(2))
                this.$set(item, 'fee', parseFloat(item.fee||0).toFixed(2))
                if (this.priceTableStyle == 'show_price') {
                    let cul = (parseFloat(item.fake_price) + parseFloat(item.fee || 0))
                    this.$set(item, 'price', cul.toFixed(2))
                    // this.$set(item, 'fake_price', parseFloat(item.price) - parseFloat(item.fee) - parseFloat(item.rate))
                } else {
                    let xx = parseFloat(item.rate) + parseFloat(item.diff_price) + parseFloat(item.fee || 0)
                    this.$set(item, 'price', xx)
                }
            } else {
                for (let key_zone in this.tableRate.courierRate) {
                    this.tableRate.courierRate[key_zone].map((item) => {
                        this.$set(item, 'price', parseFloat(item.price || 0).toFixed(2))
                        this.$set(item, 'rate', parseFloat(item.rate || 0).toFixed(2))
                        this.$set(item, 'fee', parseFloat(item.fee || 0).toFixed(2))
                        if (this.isWho() == 'superadmin') {
                            this.$set(item, 'diff_price', (parseFloat(item.price || 0) - parseFloat(item.rate || 0)).toFixed(2))
                        } else {
                            this.$set(item, 'diff_price', (parseFloat(item.price || 0) - parseFloat(item.fee || 0) - parseFloat(item.rate || 0)).toFixed(2))
                        }
                        this.$set(item, 'fake_price', parseFloat(item.price || 0) - parseFloat(item.fee || 0))
                    })
                }
            }
        },
        reloadPage() {
            location.reload()
        },
        selectCourierList(data) {
            this.inputCourier = {
                btnTitle: data.title,
                descriptionCouier: data.description,
                courierName: data.name,
                courierKey: data.key,
                refCode: data.ref_code,
                rateCode: data.default_courier_code,
                selectCourier: data.name,
                selectCourierType: data.is_shippop ? data.prebarcode ? 2 : 1 : 0,
                adminSelectCourierType: data.is_shippop ? 1 : 1,
                nameOfPic: data.icon,
                expired_date: data.expired_date,
                effective_date: data.effective_date
            }
            this.tableRate.courierRate = this.groupTypeOnRates(data.rates)
            this.generatePrice()
            // add courier
            if (['admin', 'member'].includes(this.isWho())) {
                this.permission.table.min.disabled = true
                if (!this.permission.isGen) {
                    this.permission.table.max.disabled = true
                } else {
                    this.permission.table.max.disabled = false
                }
                this.permission.table.rate.disabled = true
                this.permission.table.dimension.disabled = true
            }
        },
        handleLoader() {
            this.loader.busy = !this.loader.busy
        },
        checkBtnConfirmData() {
            // validate ข้อมูลตอนกดปุ่มยืนยัน
            this.validateData.submitted = true
            this.$refs.detailsCourier.$v.inputCourier.$touch()
            if (this.$refs.detailsCourier.$v.inputCourier.$invalid || !this.validateData.btnComfirm) {
                return false
            }
            if (this.isEdit() && (this.isWho() == 'superadmin' || this.isWho() == 'shippop')) {
                this.updateCourier()
            } else if (this.isEdit() && this.isWho() == 'admin') {
                this.adminUpdateCourier()
            } else if (!this.isEdit() && this.isWho() == 'admin') {
                this.adminAddCourier()
            } else {
                if (this.isWho() == 'superadmin' || this.isWho() == 'shippop') {
                    this.addCourier()
                }
            }
        },
        romoveObjectKey(rate) {

            let newRate = []
            Object.keys(rate).forEach(key => {

                rate[key].forEach(type => {
                    if (type['price'] == "") {
                        type['price'] = 0
                    }
                    if (type['fee'] == "") {
                        type['fee'] = 0
                    }
                    if (type['cost'] == "") {
                        type['cost'] = 0
                    }
                    if (type['rate'] == "") {
                        type['rate'] = 0
                    }

                    if (this.checkValueInObject(type)) {
                        newRate.push(type)
                    }
                })
            })
            return newRate
        },
        checkValueInObject(data) {

            let check = true
            Object.keys(data).forEach(val => {

                if (data[val] === "" && val != 'dimension') {
                    return check = false
                }
            })
            return check

        },
        checkSelectedCourierType(type) {
            if (type == 2) {
                this.inputCourier.prebarcode = 1
                return 1
            } else if (this.isWho() == 'admin' && this.inputCourier.adminSelectCourierType == 0) {
                return 0
            } else {
                return type
            }
        },
        groupTypeOnRates(array, key = 'type') {
            let zones = {}

            if (this.inputCourier.courierKey == 'JNT') {
                const zoneObj = COURIER.setCourier(this.inputCourier.courierKey).getAvaliableZones()

                zones = Object.entries(zoneObj).reduce((acc, [k, v]) => {
                    acc[v] = k

                    return acc
                }, {})
            }

            return array.reduce((result, currentValue) => {
                let type = currentValue[key]
                let courierKey = this.inputCourier.courierKey
                if (this.inputCourier.courierKey == 'FLEB') {
                    if (type == 1 ) {
                        type = 'BKK_TO_BKK'
                    } else if (type == 2 ) {
                        type = 'BKK_TO_UPC'
                    } else if (type == 3 ) {
                        type = 'UPC_WITH_SAME_PROVINCE'
                    } else if (type == 4 ) {
                        type = 'UPC_TO_UPC'
                    } else if (type == 5 ) {
                        type = 'UPC_TO_BKK'
                    }
                } else if (['FLE', 'FLEF', 'FLEWP'].includes(courierKey)) {
                    if (
                        courierKey == 'FLE' && this.inputCourier.effective_date && 
                        ( new Date(this.inputCourier.effective_date) >= new Date('2022-03-16 00:00:00') 
                            && new Date(this.inputCourier.effective_date) < new Date('2022-03-20 00:00:00') 
                        ) ||
                            new Date(this.inputCourier.effective_date) >= new Date("2022-03-23 00:00:00")
                    ) {
                            if (type == 1) {
                                type = 'BKK_TO_BKK'
                            } else if (type == 2) {
                                type = 'BKK_TO_N_NE_S_C'
                            } else if (type == 3) {
                                type = 'N_NE_S_C_TO_BKK'
                            } else if (type == 4) {
                                type = 'N_TO_N_NE_S_C'
                            } else if (type == 5) {
                                type = 'NE_TO_N_NE_S_C'
                            } else if (type == 6) {
                                type = 'S_TO_N_NE_S_C'
                            } else if (type == 7) {
                                type = 'C_TO_N_NE_S_C'
                            } else if (type == 8) {
                                type = 'SAME_N_TO_N_NE_S_C'
                            } else if (type == 9) {
                                type = 'SAME_NE_TO_N_NE_S_C'
                            } else if (type == 10) {
                                type = 'SAME_S_TO_N_NE_S_C'
                            } else if (type == 11) {
                                type = 'SAME_C_TO_N_NE_S_C'
                            } 
                    } else {
                        if (type == 1) {
                            type = 'same_N_NE_S'
                        } else if (type == 2){
                            type = 'to_BKK'
                        } else if (type == 3) {
                            type = 'N'
                        } else if (type == 4) {
                            type = 'NE'
                        } else if (type == 5) {
                            type = 'S'
                        } else if (type == 6) {
                            type = 'same_BKK'
                        } else if (type == 7) {
                            type = 'from_BKK_C_to_no_BKK'
                        } else if (type == 8) {
                            type = 'same_C'
                        }  else if (type == 9) {
                            type = 'C_to_BKK'
                        }
                    }
                } else if (courierKey == 'SCGC' || courierKey == 'SCGF') {
                    if (type == 1) {
                        type = 'SAMEPV'
                    } else if (type == 2) {
                        type = 'BKK'
                    } else if (type == 3) {
                        type = 'UPC'
                    } else {
                        type = 'Default'
                    }
                } else if (courierKey == 'BEST') {
                    if (new Date(this.inputCourier.effective_date) >= new Date('2023-12-15 00:00:00')) {
                        if (type == 1) {
                            type = 'GBKK_GBKK'
                        } else if (type == 2) {
                            type = 'GBKK_C-N-NE'
                        } else if (type == 3) {
                            type = 'GBKK_S'
                        } else if (type == 4) {
                            type = 'C-N-NE_GBKK'
                        } else if (type == 5) {
                            type = 'C-N-NE_S'
                        } else if (type == 6) {
                            type = 'C-N-NE_C-N-NE'
                        } else if (type == 7) {
                            type = 'S_GBKK'
                        } else if (type == 8) {
                            type = 'S_C-N-NE'
                        } else if (type == 9) {
                            type = 'S_S'
                        }
                    } else if (new Date(this.inputCourier.effective_date) >= new Date('2022-01-13 00:00:00')) {
                        if (type == 1) {
                            type = 'BKK_TO_BKK';
                        } else if (type == 2) {
                            type = 'BKK_TO_UPC'; 
                        } else if (type == 3) {
                            type = 'UPC_TO_BKK';
                        } else if (type == 4) {
                            type = 'UPC_TO_UPC';
                        }
                    } else {
                        // logic เรทเก่า
                        if (type == 1) {
                            type = 'BKK'
                        } else if (type == 2) {
                            type = 'C'
                        } else if (type == 3) {
                            type = 'N'
                        } else if (type == 4) {
                            type = 'NE'
                        } else if (type == 5) {
                            type = 'S'
                        } else if (type == 6) {
                            type = 'SAME'
                        } else if (type == 7) {
                            type = 'SAME_C'
                        } else {
                            type = 'Default'
                        }
                    }
                } else if (
                    new Date().getTime() >= new Date('2023-01-01 00:00:00').getTime() &&
                    ['MSE', 'MSEC', 'MSEF', 'SPE', 'SPEC'].includes(this.inputCourier.courierKey) 
                ) {
                    console.log('type on rate mse xxx')
                    if (type == 1) {
                        type = 'BKK_GBKK_TO_BKK'
                    } else if (type == 2) {
                        type = 'BKK_GBKK_TO_GBKK'
                    }
                } else if (['MSE', 'MSEC', 'SPE', 'SPEC'].includes(courierKey)) {
                    if (type == 1) {
                        type = 'BKK_GBKK_TO_BKK'
                    } else if (type == 2) {
                        type = 'BKK_GBKK_TO_GBKK'
                    } else if (type == 3) {
                        //'ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง:	ต่างจังหวัด (ชลบุรี, ราชบุรี, เพชรบุรี, หัวหิน, สมุทรสงคราม, นครราชสีมา)'
                        type = 'BKK_GBKK_TO_UPC'
                    } else if (type == 4) {
                        type = 'CBI'
                    } else if (type == 5) {
                        type = 'CBI_TO_BKK_GBKK'
                    } else if (type == 6) {
                        type = 'SAME_PBI_HUAHIN_SKM_RBR'
                    } else if (type == 7) {
                        type = 'NEAR_IN_PBI_HUAHIN_SKM_RBR'
                    } else if (type == 8) {
                        type = 'PBI_HUAHIN_SKM_RBR_TO_BKK_GBKK'
                    } else if (type == 9) {
                        type = 'SAME_KKN_NMA'
                    } else if (type == 10) {
                        type = 'NRT'
                    } else if (type == 11) {
                        type = 'NRT_TO_BKK_GBKK'
                    }
                } else if (courierKey == 'TPSD') {
                    if (type == 1) {
                        type = 'DEFAULT'
                    }
                }else if ( courierKey === _COURIERS_.DHL.key ) {
                    if (type == 1) {
                        type = 'BKK'
                    }else if(type == 2){
                        type = 'C'
                    }else{
                        type = 'UPC'
                    }
                } else if (
                    ['KRYS', 'KRYQ'].includes(this.inputCourier.courierKey) && 
                    this.inputCourier.effective_date && 
                    new Date(this.inputCourier.effective_date).getTime() >= new Date('2023-09-05 00:00:00').getTime()
                ) {
                    // force update courie rules 
                    let indexKerry = CourierRules.dimensionCouriers.indexOf('KRYS');
                    if (indexKerry !== -1) {
                        this.courierCheck.dimension = CourierRules.dimensionCouriers.splice(indexKerry, 1);
                    }
                    let indexQuick = CourierRules.dimensionCouriers.indexOf('KRYQ');
                    if (indexQuick !== -1) {
                        this.courierCheck.dimension = CourierRules.dimensionCouriers.splice(indexQuick, 1);
                    }
                    if (type == 1) {
                        type = 'SAME_PROVINCE';
                    } else if (type == 2) {
                        type = 'WITHIN_1200KM';
                    } else if (type == 3) {
                        type = 'MORE_THAN_1200KM';
                    }
                } else if (courierKey == 'KRYS') {
                    if (type == 1) {
                        type = 'BKK_TO_BKK'
                    } else if (type == 2) {
                        type = 'BKK_TO_UPC'
                    } else if (type == 3) {
                        type = 'UPC23_SAME_PROVINCE'
                    } else if (type == 4) {
                        type = 'UPC23_SAME_UPC23'
                    } else if (type == 5) {
                        type = 'UPC23_TO_UPC'
                    } else if (type == 6) {
                        type = 'UPC50_SAME_PROVINCE'
                    } else if (type == 7) {
                        type = 'UPC50_SAME_UPC50'
                    } else if (type == 8) {
                        type = 'PBI_HUAHIN_SKM_RBR_TO_BKK_GBKK'
                    } else {
                        type = 'UPC50_TO_UPC'
                    }
                } else if (['KRYQ'].includes(courierKey)) {
                    if( type == 1 ){
                        type = 'BKKG_TO_BKKG'
                    }else if ( type == 2 ){
                        type = 'BKKG_TO_UPC'
                    }else if ( type == 3 ){
                        type = 'C_E_TO_BKKG'
                    }else if ( type == 4 ){
                        type = 'C_E_TO_ALL'
                    }else if ( type == 5 ){
                        type = 'C_E_SAME_PROVINCE'
                    }else if ( type == 6 ){
                        type = 'N_NE_S_TO_BKKG'
                    }else if ( type == 7 ){
                        type = 'N_TO_ALL'
                    }else if ( type == 8 ){
                        type = 'NE_TO_ALL'
                    }else if ( type == 9 ){
                        type = 'S_TO_ALL'
                    }else if ( type == 10 ){
                        type = 'N_SAME_PROVINCE'
                    }else if ( type == 11 ){
                        type = 'NE_SAME_PROVINCE'
                    }else if ( type == 12 ){
                        type = 'S_SAME_PROVINCE'
                    }else{
                        type = null
                    }
                } else if (['ORNG'].includes(courierKey)) {
                    if( type == 1 ){
                        type = 'BKKG_TO_BKKG'
                    }else if ( type == 2 ){
                        type = 'BKKG_TO_UPC'
                    }else if ( type == 3 ){
                        type = 'C_E_W_TO_BKKG'
                    }else if ( type == 4 ){
                        type = 'C_E_W_TO_ALL'
                    }else if ( type == 5 ){
                        type = 'C_E_W_SAME_PROVINCE'
                    }else if ( type == 6 ){
                        type = 'N_NE_S_TO_BKKG'
                    }else if ( type == 7 ){
                        type = 'N_TO_ALL'
                    }else if ( type == 8 ){
                        type = 'NE_TO_ALL'
                    }else if ( type == 9 ){
                        type = 'S_TO_ALL'
                    }else if ( type == 10 ){
                        type = 'N_SAME_PROVINCE'
                    }else if ( type == 11 ){
                        type = 'NE_SAME_PROVINCE'
                    }else if ( type == 12 ){
                        type = 'S_SAME_PROVINCE'
                    }else{
                        type = null
                    }
                } else if(courierKey == 'SPXP') {
                    if (new Date(this.inputCourier.effective_date) >= new Date('2022-11-01 00:00:00')) {
                        
                        if (type == 1) type = 'BKK_TO_BKK';
                        if (type == 2) type = 'BKK_TO_UPC';
                        if (type == 3) type = 'UPC_TO_BKK';
                        if (type == 4) type = 'UPC_TO_UPC';
                    
                    } else {
                        if (type == 1) type = 'BKK';
                        if (type == 2) type = 'UPC';
                       
                    }
                } else if(['XPSO','XPSD'].includes(courierKey)) {
                    if (type == 1){
                        type = 'GBKK_TO_GBKK';
                    }
                }else if (courierKey == 'JNT') {
                    if (zones[type]) {
                        type = zones[type]
                    }
                } else {
                    if (type == 1) {
                        type = 'BKK'
                    } else if (type == 2) {
                        type = 'UPC'
                    } else {
                        type = 'Default'
                    }
                }
                (result[type] = result[type] || []).push(currentValue)
                return result

            }, {})
        },
        adminAddCourier() {
            this.handleLoader()
            this.$http
                .post(
                    API_URL + "/shop/courier", {
                        key: this.inputCourier.courierKey,
                        name: this.inputCourier.courierName,
                        title: this.inputCourier.btnTitle,
                        shippop: this.checkSelectedCourierType(this.inputCourier.selectCourierType),
                        description: this.inputCourier.descriptionCouier,
                        rates: this.romoveObjectKey(this.tableRate.courierRate),
                        prebarcode: this.inputCourier.prebarcode,
                        icon: this.inputCourier.nameOfPic,
                        expired_date: this.inputCourier.expired_date,
                        effective_date: this.inputCourier.effective_date,
                        ref_code: this.inputCourier.refCode,
                        default_courier_code: this.inputCourier.rateCode
                    }, {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    if (result.status == true) {
                        this.handleLoader()
                        this.modalSuccess('เพิ่มข้อมูลเรียบร้อยค่ะ', result.data.id)
                    }
                })
                .catch(() => {});
        },
        addCourier() {
            this.handleLoader()
            this.$http
                .post(
                    API_URL + "/shop/superadmin/courier", {
                        key: this.inputCourier.courierKey,
                        ref_code: this.inputCourier.refCode,
                        name: this.inputCourier.courierName,
                        title: this.inputCourier.btnTitle,
                        is_shippop: this.checkSelectedCourierType(this.inputCourier.selectCourierType),
                        description: this.inputCourier.descriptionCouier,
                        rates: this.romoveObjectKey(this.tableRate.courierRate),
                        prebarcode: this.inputCourier.prebarcode,
                        icon: this.inputCourier.nameOfPic,
                        default_courier_code: this.inputCourier.rateCode,
                        effective_date: (this.isWho() == 'shippop' && this.inputCourier.effective_date) ? this.setFormatDateTimeSaveDatabase(this.inputCourier.effective_date) : this.inputCourier.effective_date,
                        expired_date: (this.isWho() == 'shippop' && this.inputCourier.expired_date) ? this.setFormatDateTimeSaveDatabase(this.inputCourier.expired_date) : this.inputCourier.expired_date
                    }, {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    if (result.status == true) {
                        this.handleLoader()
                        this.modalSuccess('เพิ่มข้อมูลเรียบร้อยค่ะ', result.data.id)
                    }
                })
                .catch(() => {});
        },
        superadminGetCourierForUpdate() {
            this.handleLoader()
            this.$http
                .get(API_URL + `/shop/superadmin/courier/${this.$route.params.Id}`, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let data = res.data.data[0]
                    this.inputCourier = {
                        btnTitle: data.title,
                        descriptionCouier: data.description,
                        courierName: data.name,
                        courierKey: data.key,
                        refCode: data.ref_code,
                        rateCode: data.default_courier_code,
                        selectCourier: data.title,
                        selectCourierType: data.is_shippop ? data.prebarcode ? 2 : 1 : 0,
                        effective_date: (this.isWho() == 'shippop' && data.effective_date) ? this.setFormatDateTimeLocal(data.effective_date) : data.effective_date,
                        expired_date: (this.isWho() == 'shippop' && data.expired_date) ? this.setFormatDateTimeLocal(data.expired_date) : data.expired_date,
                        createdAt: data.created_at,
                        updatedAt: data.updated_at,
                        isEditRate: data.is_edit_rate
                    }
                    console.log('sp get update')
                    this.tableRate.courierRate = this.groupTypeOnRates(data.rates)
                    this.generatePrice()
                    this.handleLoader()

                })
                .catch(() => {});
        },
        adminGetCourierForUpdate() {
            this.handleLoader()
            this.$http
                .get(API_URL + `/shop/courier/${this.$route.params.Id}`, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let data = res.data.data[0]
                    this.inputCourier = {
                        btnTitle: data.title,
                        descriptionCouier: data.description,
                        courierName: data.name,
                        courierKey: data.key,
                        refCode: data.ref_code,
                        rateCode: data.default_courier_code,
                        selectCourier: data.title,
                        selectCourierType: data.shippop ? data.prebarcode ? 2 : 1 : 0,
                        effective_date: data.effective_date,
                        expired_date: data.expired_date
                    }
                    this.tableRate.courierRate = this.groupTypeOnRates(data.rates)
                    this.generatePrice()
                    this.handleLoader()
                })
                .catch(() => {});
        },
        adminUpdateCourier() {
            this.handleLoader()
            this.$http
                .put(
                    API_URL + `/shop/courier/${this.$route.params.Id}`, {
                        key: this.inputCourier.courierKey,
                        ref_code: this.inputCourier.refCode,
                        name: this.inputCourier.courierName,
                        title: this.inputCourier.btnTitle,
                        description: this.inputCourier.descriptionCouier,
                        rates: this.romoveObjectKey(this.tableRate.courierRate),
                        effective_date: this.inputCourier.effective_date,
                        expired_date: this.inputCourier.expired_date
                    }, {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    if (result.status == true) {
                        this.handleLoader()
                        this.modalSuccess('แก้ไขข้อมูลเรียบร้อยค่ะ')
                    }
                })
                .catch(() => {});
        },
        updateCourier() {
            this.handleLoader()
            this.$http
                .put(
                    API_URL + `/shop/superadmin/courier/${this.$route.params.Id}`, {
                        key: this.inputCourier.courierKey,
                        ref_code: this.inputCourier.refCode,
                        name: this.inputCourier.courierName,
                        title: this.inputCourier.btnTitle,
                        description: this.inputCourier.descriptionCouier,
                        rates: this.romoveObjectKey(this.tableRate.courierRate),
                        effective_date: (this.isWho() == 'shippop' && this.inputCourier.effective_date) ? this.setFormatDateTimeSaveDatabase(this.inputCourier.effective_date) : this.inputCourier.effective_date,
                        expired_date: (this.isWho() == 'shippop' && this.inputCourier.expired_date) ? this.setFormatDateTimeSaveDatabase(this.inputCourier.expired_date) : this.inputCourier.expired_date
                    }, {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    if (result.status == true) {
                        this.handleLoader()
                        this.modalSuccess('แก้ไขข้อมูลเรียบร้อยค่ะ')
                    }
                })
                .catch(() => {});
        },
        checkCourierZone(k) {
            console.log('check zone', k)
            let key = this.inputCourier.courierKey
            if (key == 'FLEB') {
                if (k == 'BKK_TO_BKK') {
                    k = 1;
                } else if (k == 'BKK_TO_UPC') {
                    k = 2;
                } else if (k == 'UPC_WITH_SAME_PROVINCE') {
                    k = 3;
                } else if (k == 'UPC_TO_UPC') {
                    k = 4;                
                } else if (k == 'UPC_TO_BKK') {
                    k = 5;    
                }        
            } else if (['FLE', 'FLEF', 'FLEWP'].includes(key)) {
                if (
                    key == 'FLE' && this.inputCourier.effective_date && 
                    ( new Date(this.inputCourier.effective_date) >= new Date('2022-03-16 00:00:00') 
                        && new Date(this.inputCourier.effective_date) < new Date('2022-03-20 00:00:00') 
                    ) 
                    ||
                        new Date(this.inputCourier.effective_date) >= new Date('2022-03-23 00:00:00')
                ) {
                    // Flash 11 zone
                    if ( k == 'BKK_TO_BKK') {
                        k = 1
                    } else if ( k == 'BKK_TO_N_NE_S_C') {
                        k = 2
                    } else if ( k == 'N_NE_S_C_TO_BKK') {
                        k = 3
                    } else if ( k == 'N_TO_N_NE_S_C') {
                        k = 4
                    } else if ( k == 'NE_TO_N_NE_S_C') {
                        k = 5
                    } else if ( k == 'S_TO_N_NE_S_C') {
                        k = 6
                    } else if ( k == 'C_TO_N_NE_S_C') {
                        k = 7
                    } else if ( k == 'SAME_N_TO_N_NE_S_C') {
                        k = 8
                    } else if ( k == 'SAME_NE_TO_N_NE_S_C') {
                        k = 9
                    } else if ( k == 'SAME_S_TO_N_NE_S_C') {
                        k = 10
                    } else if ( k == 'SAME_C_TO_N_NE_S_C') {
                        k = 11
                    }
                } else {
                    // Flash 9 zone
                    if (k == 'same_N_NE_S') {
                        k = 1
                    } else if (k == 'to_BKK') {
                        k = 2
                    } else if (k == 'N') {
                        k = 3
                    } else if (k == 'NE') {
                        k = 4
                    } else if (k == 'S') {
                        k = 5
                    } else if (k == 'same_BKK') {
                        k = 6
                    } else if (k == 'from_BKK_C_to_no_BKK') {
                        k = 7
                    } else if (k == 'same_C') {
                        k = 8
                    }  else if (k == 'C_to_BKK') {
                        k = 9
                    }  else {
                        k = null
                    }
                }
            } else if (key == 'SCGC' || key == 'SCGF') {
                if (k == 'SAMEPV') {
                    k = 1
                } else if (k == 'BKK') {
                    k = 2
                } else if (k == 'UPC') {
                    k = 3
                } else {
                    k = null
                }
            } else {
                if (['BKK', 'GBKK_TO_GBKK', 'DEFAULT'].includes(k)) {
                    k = 1
                } else if (k == 'UPC') {
                    k = 2
                } else {
                    k = null
                }
            }

            return k
        },
        addNewRate(k, i) {
            let courier = this.tableRate.courierRate[k]
            if (courier.length == i + 1) {
                if (courier[i].min <= courier[i].max) {
                    courier.push({
                        type: this.checkCourierZone(k),
                        min: +courier[i].max + 1,
                        max: "",
                        cost: "",
                        price: "",
                        rate: "",
                        // price: null,
                        // fee: null,
                        // dimension: ""
                    })
                }

            }
        },
        autoUpdateRateMax(k, i) {
            let courier = this.tableRate.courierRate[k]
            if (typeof courier[i + 1] !== 'undefined') {
                courier[i + 1].min = +courier[i].max + 1
            }

        },
        deleteRate(k, i) {
            this.tableRate.courierRate[k].splice(i, 1);
        },
        defaultCourierRate() {
            return {
                Default: [{
                    type: null,
                    min: 1,
                    max: "",
                    cost: "",
                    price: "",
                    rate: "",
                    // price: null,
                    // fee: null,
                    // dimension: ""
                }]
            }
        },
        pushCourierRate(zone = null) {
            return [{
                type: zone,
                min: 1,
                max: "",
                cost: "",
                price: "",
                rate: "",
                // fee: null,
                // dimension: ""
            }]
        },
        modalSuccess(msgBody, idCOurier = false) {
            this.$bvModal
                .msgBoxOk(msgBody, {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                })
                .then(value => {
                    if (value && idCOurier) {
                        this.$router.push(`/transport/${idCOurier}`)
                        this.permission.samePage = true
                    } else {
                        window.location.reload();
                    }
                });
        },
        isEdit() {
            return !!this.$route.params.Id;
        },
        isWho() {
            return this.userLogin.role;
        },
        logoCourier(shippopKeys, key, selectCourierType) {
            const isPreBarcode = selectCourierType==2?true:false
            let logo = shippopKeys.find((courier) => {
                return courier == key
            })
            
            if (logo) {
                if (logo == 'TP2') {
                    logo = 'TP2.png'
                } else if (logo == 'THP') {
                    logo = 'THP.png'
                } else if (logo == 'EMST') {
                    logo = 'EMST.png'
                } else if (logo == 'EMSW') {
                    logo = 'EMSW.png'
                } else if (logo == 'EMSX') {
                    logo = 'EMSX.png'
                } else if (logo == 'CJLX') {
                    logo = 'CJLX.png'
                } else if (logo == 'NJV') {
                    logo = 'NJV.png'
                } else if (logo == 'FLEWP') {
                    logo = 'FLEWP.png'
                } else if (logo == 'FLEB') {
                    logo = 'FLEB.png'
                } else if (logo == 'FLE') {
                    let courierName = this.inputCourier.courierName.replaceAll(/\s/g,'')
                    .toLowerCase()
                    let patt = /nodimension/i;
                    if ( courierName.match(patt) ) {
                        logo = 'FLE_NO_DIMENSION.jpg'
                    } else if (/quickexpress/ig.test(courierName)) {
                        logo = 'QUICK.png'
                    } else {
                        logo = 'FLE.png'
                    }
                } else if (logo == 'FLEF') {
                    logo = 'FLEF.png'
                } 
                else if (logo == 'TRUE') {
                    logo = 'true-logistics.png'
                } else if (logo == 'SCG') {
                    logo = 'scg-express-yamato.png'
                } else if (logo == 'SCGC') {
                    logo = 'scg-cool.png'
                } else if (logo == 'SCGF') {
                    logo = 'scg-frozen.png'
                } else if (logo == 'JNT') {
                    logo = 'JNT.png'
                } else if (logo == 'ECP') {
                    logo = 'ECP.png'
                } else if (logo == 'BEST') {
                    logo = 'BEST.png'
                }else if (logo == 'BEE') {
                    logo = 'BEE.png'
                }else if (logo == 'TPSD') {
                    logo = 'TPSD.png'
                }else if (logo == 'MSE') {
                    logo = 'MSE.png'
                }else if (logo == 'MSEC') {
                    logo = 'MSEC.png'
                }else if (logo == 'MSEF') {
                    logo = 'MSEF.png'
                }else if (logo == 'SPE') {
                    logo = 'SPE.png'
                }else if (logo == 'SPEC') {
                    logo = 'SPEC.png'
                }else if (logo == _COURIERS_.DHL.key) {
                    logo = _COURIERS_.DHL.logo
                }else if (logo == 'KRYS') {
                    logo = 'KRYS.png'
                }else if (logo == 'KRYQ') {
                    logo = 'KRYQ.png'
                }else if (logo == 'ORNG') {
                    logo = 'ORNG.png'
                }else if (logo == 'SPXP') {
                    logo = 'SPXP.png'
                }else if (logo == 'EMSXP') {
                    logo = 'EMSXP.png'
                    if( this.$THEME.name == 'poststation' ){
                        logo = 'THP.png'
                    }
                }else if (logo == 'XPSO') {
                    logo = 'XPSO.png'
                }else if (logo == 'XPSD') {
                    logo = 'XPSD.png'
                }else {
                    logo = ''
                }
                if (isPreBarcode) {
                    logo = 'PRE_' + logo
                }
            } else {
                logo = ''
            }

            return logo
        },
        checkCourierKeys(eventChange = false) {
            let shippopKeys = this.courierCheck.shippopCourierKeys
            // console.log('this.couriercheck', this.courierCheck)
            let key = this.inputCourier.courierKey
            this.inputCourier.nameOfPic = this.logoCourier(shippopKeys, key, this.inputCourier.selectCourierType)
            // ตรวจสอบ key ที่ shippop อนุญาตให้สร้าง
            if (key.length > 2 || eventChange) {
                if (key.includes('GEN', 'SPGEN')) {
                    this.validateData.btnComfirm = true
                    this.validateData.checkInput.courierKey = true
                } else {
                    if (shippopKeys.includes(key)) {
                        this.validateData.btnComfirm = true
                        this.validateData.checkInput.courierKey = true
                    } else {
                        this.validateData.btnComfirm = false
                        this.validateData.checkInput.courierKey = false
                    }
                }
            } else {
                this.validateData.checkInput.courierKey = null
            }
        },
        checkCourierDimension() {
            if( // TODO: remove after 5 sep
                ['KRYS', 'KRYQ'].includes(this.inputCourier.courierKey) && 
                new Date(this.inputCourier.effective_date).getTime() >= new Date('2023-09-05 00:00:00').getTime()
            ) {
                let index = this.courierCheck.dimension.indexOf('KRYS');
                if (index !== -1) {
                    this.courierCheck.dimension.splice(index, 1);
                }
                let indexQuick = this.courierCheck.dimension.indexOf('KRYQ');
                if (indexQuick !== -1) {
                    this.courierCheck.dimension.splice(indexQuick, 1);
                }
                console.log('kerry effective after 5 sep', this.courierCheck.dimension)
            }
            if (
                this.courierCheck.dimension.includes(this.inputCourier.courierKey)
            ) {
                this.permission.table.dimension.show = true
                return true;
            } else {
                this.permission.table.dimension.show = false
                return false;
            }
        },
        setFormatDateTimeLocal( dateTime ){
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm")
        },
        setFormatDateTimeSaveDatabase( dateTime ){
            return moment(dateTime, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD HH:mm:ss")
        },
        checkDisableUpdatePrice() {
            return !this.$USER_LOGIN.get().isShippop && CourierRules[this.inputCourier.courierKey] && CourierRules[this.inputCourier.courierKey].lockPrice
        },
        checkUpdateForOneSuperadmin(){
            return this.$USER_LOGIN.get().isSuperadmin && this.isEdit() && !this.inputCourier.isEditRate
        },
        filterTab: debounce(async (key, _this) => {
            _this.handleLoader()
            const elements = document.querySelectorAll('.table-rate > .tabs > .card-header > ul > li')

            if (key === 'JNT' && _this.isWho() !== 'shippop' && _this.isWho() !== 'superadmin') {
                const c = COURIER.setCourier(key)
                const filter = await c.filterZone()

                if (filter) {
                    const map = filter.map((f) => c.mapAvaliableZoneName(f))
    
                    elements.forEach((el) => {
                        if (map.includes(el.textContent)) {
                            el.style.display = 'list-item'
                        }
                    })
                }
            } else {    
                elements.forEach((el) => {
                    el.style.display = 'list-item'
                })
            }

            const tb = document.querySelector('.table-rate')
            const excelRate = document.querySelector('.excel-rate')

            if (tb && excelRate) {
                tb.style.display = 'flex'
                excelRate.style.display = 'flex'
            }

            _this.handleLoader()
        }, 300),
        updateCourierZone () {
            let key = this.inputCourier.courierKey
            let extraCouriers = this.courierCheck.extraCouriers

            this.filterTab(key, this)

            this.checkCourierKeys()
            this.checkCourierDimension()
            // console.log('update courier zone', this.inputCourier.effective_date)
            // ตรวจสอบขนส่งที่เก็บค่าบริการเพิ่ม ถ้าส่งต่างจังหวัด
            if (extraCouriers.includes(key) && 
                !this.isEdit() && (this.isWho() == 'superadmin' || this.isWho() == 'shippop')) {
                if (key == 'FLEB') {
                    this.tableRate.courierRate = {
                        'BKK_TO_BKK': this.pushCourierRate(1),
                        'BKK_TO_UPC': this.pushCourierRate(2),
                        'UPC_WITH_SAME_PROVINCE': this.pushCourierRate(3),
                        'UPC_TO_UPC': this.pushCourierRate(4),
                        'UPC_TO_BKK': this.pushCourierRate(5)
                    }
                } else if (['FLE', 'FLEF', 'FLEWP'].includes(key)) {
                    console.log('doing something on there ')
                    this.$set(this.tableRate, 'courierRate', {})
                    if ( (key == 'FLE' && this.inputCourier.effective_date && 
                        new Date(this.inputCourier.effective_date) >= new Date('2022-03-16 00:00:00') &&
                        (new Date(this.inputCourier.effective_date) < new Date('2022-03-20 00:00:00') ||
                        new Date(this.inputCourier.effective_date) >= new Date('2022-03-23 00:00:00'))) || key == 'FLEF'
                        
                    ) {
                        this.tableRate.courierRate = {
                            BKK_TO_BKK: this.pushCourierRate(1),
                            BKK_TO_N_NE_S_C: this.pushCourierRate(2),
                            N_NE_S_C_TO_BKK: this.pushCourierRate(3),
                            N_TO_N_NE_S_C: this.pushCourierRate(4),
                            NE_TO_N_NE_S_C: this.pushCourierRate(5),
                            S_TO_N_NE_S_C: this.pushCourierRate(6),
                            C_TO_N_NE_S_C: this.pushCourierRate(7),
                            SAME_N_TO_N_NE_S_C: this.pushCourierRate(8),
                            SAME_NE_TO_N_NE_S_C: this.pushCourierRate(9),
                            SAME_S_TO_N_NE_S_C: this.pushCourierRate(10),
                            SAME_C_TO_N_NE_S_C: this.pushCourierRate(11)
                        }
                    } else {
                        this.tableRate.courierRate = {
                            same_N_NE_S: this.pushCourierRate(1),
                            to_BKK: this.pushCourierRate(2),
                            N: this.pushCourierRate(3),
                            NE: this.pushCourierRate(4),
                            S: this.pushCourierRate(5),
                            same_BKK: this.pushCourierRate(6),
                            from_BKK_C_to_no_BKK: this.pushCourierRate(7),
                            same_C: this.pushCourierRate(8),
                            C_to_BKK: this.pushCourierRate(9)
                        }
                    }
                } else if (key == 'SCGC' || key == 'SCGF') {
                    this.tableRate.courierRate = {
                        SAMEPV: this.pushCourierRate(1),
                        BKK: this.pushCourierRate(2),
                        UPC: this.pushCourierRate(3),
                    }
                } else if (key == 'BEST') {
                    if (this.inputCourier.effective_date && new Date(this.inputCourier.effective_date) >= new Date('2023-12-15 00:00:00')) {
                        this.tableRate.courierRate = {
                            GBKK_GBKK: this.pushCourierRate(1),
                            "GBKK_C-N-NE": this.pushCourierRate(2),
                            GBKK_S: this.pushCourierRate(3),
                            "C-N-NE_GBKK": this.pushCourierRate(4),
                            "C-N-NE_S": this.pushCourierRate(5),
                            "C-N-NE_C-N-NE": this.pushCourierRate(6),
                            S_GBKK: this.pushCourierRate(7),
                            "S_C-N-NE": this.pushCourierRate(8),
                            S_S: this.pushCourierRate(9),
                        }
                    } else if (this.inputCourier.effective_date && new Date(this.inputCourier.effective_date) >= new Date('2022-01-13 00:00:00')) {
                        this.tableRate.courierRate = {
                            BKK_TO_BKK: this.pushCourierRate(1),
                            BKK_TO_UPC: this.pushCourierRate(2),
                            UPC_TO_BKK: this.pushCourierRate(3),
                            UPC_TO_UPC: this.pushCourierRate(4)
                        }
                    } else {
                        this.tableRate.courierRate = {
                            BKK: this.pushCourierRate(1),
                            C: this.pushCourierRate(2),
                            N: this.pushCourierRate(3),
                            NE: this.pushCourierRate(4),
                            S: this.pushCourierRate(5),
                            SAME: this.pushCourierRate(6),
                        }
                    }
                } else if (
                    this.inputCourier.effective_date && 
                    new Date(this.inputCourier.effective_date) >= new Date('2023-01-01 00:00:00') &&
                    ['MSE', 'MSEC', 'MSEF', 'SPE', 'SPEC'].includes(key)) {
                        console.log('push rate 2')
                    this.tableRate.courierRate = {
                        'BKK_GBKK_TO_BKK': this.pushCourierRate(1),
                        'BKK_GBKK_TO_GBKK': this.pushCourierRate(2)
                    }
                } else if (['MSE', 'MSEC', 'SPE', 'SPEC'].includes(key)) {
                    this.tableRate.courierRate = {
                        'BKK_GBKK_TO_BKK': this.pushCourierRate(1),
                        'BKK_GBKK_TO_GBKK': this.pushCourierRate(2),
                        'BKK_GBKK_TO_UPC': this.pushCourierRate(3),
                        'CBI': this.pushCourierRate(4),
                        'CBI_TO_BKK_GBKK': this.pushCourierRate(5),
                        'SAME_PBI_HUAHIN_SKM_RBR': this.pushCourierRate(6),
                        'NEAR_IN_PBI_HUAHIN_SKM_RBR': this.pushCourierRate(7),
                        'PBI_HUAHIN_SKM_RBR_TO_BKK_GBKK': this.pushCourierRate(8),
                        'SAME_KKN_NMA': this.pushCourierRate(9),
                        'NRT': this.pushCourierRate(10),
                        'NRT_TO_BKK_GBKK': this.pushCourierRate(11),
                    }
                } else if (
                    ['KRYS', 'KRYQ'].includes(this.inputCourier.courierKey) && 
                    this.inputCourier.effective_date && 
                    new Date(this.inputCourier.effective_date).getTime() >= new Date('2023-09-05 00:00:00').getTime()
                ) {
                    this.tableRate.courierRate = {
                        SAME_PROVINCE: this.pushCourierRate(1),
                        WITHIN_1200KM: this.pushCourierRate(2),
                        MORE_THAN_1200KM: this.pushCourierRate(3)
                    }
                } else if (key === 'KRYS') {
                    this.tableRate.courierRate = {
                        BKK_TO_BKK: this.pushCourierRate(1),
                        BKK_TO_UPC: this.pushCourierRate(2),
                        UPC23_SAME_PROVINCE: this.pushCourierRate(3),
                        UPC23_SAME_UPC23: this.pushCourierRate(4),
                        UPC23_TO_UPC: this.pushCourierRate(5),
                        UPC50_SAME_PROVINCE: this.pushCourierRate(6),
                        UPC50_SAME_UPC50: this.pushCourierRate(7),
                        UPC50_TO_UPC: this.pushCourierRate(8),
                    }
                } else if ( ['KRYQ'].includes(key)) {
                    this.tableRate.courierRate = {
                        'BKKG_TO_BKKG': this.pushCourierRate(1),
                        'BKKG_TO_UPC': this.pushCourierRate(2),
                        'C_E_TO_BKKG': this.pushCourierRate(3),
                        'C_E_TO_ALL': this.pushCourierRate(4),
                        'C_E_SAME_PROVINCE': this.pushCourierRate(5),
                        'N_NE_S_TO_BKKG': this.pushCourierRate(6),
                        'N_TO_ALL': this.pushCourierRate(7),
                        'NE_TO_ALL': this.pushCourierRate(8),
                        'S_TO_ALL': this.pushCourierRate(9),
                        'N_SAME_PROVINCE': this.pushCourierRate(10),
                        'NE_SAME_PROVINCE': this.pushCourierRate(11),
                        'S_SAME_PROVINCE': this.pushCourierRate(12)
                    }
                } else if(['ORNG'].includes(key)) {
                    this.tableRate.courierRate = {
                        'BKKG_TO_BKKG': this.pushCourierRate(1),
                        'BKKG_TO_UPC': this.pushCourierRate(2),
                        'C_E_W_TO_BKKG': this.pushCourierRate(3),
                        'C_E_W_TO_ALL': this.pushCourierRate(4),
                        'C_E_W_SAME_PROVINCE': this.pushCourierRate(5),
                        'N_NE_S_TO_BKKG': this.pushCourierRate(6),
                        'N_TO_ALL': this.pushCourierRate(7),
                        'NE_TO_ALL': this.pushCourierRate(8),
                        'S_TO_ALL': this.pushCourierRate(9),
                        'N_SAME_PROVINCE': this.pushCourierRate(10),
                        'NE_SAME_PROVINCE': this.pushCourierRate(11),
                        'S_SAME_PROVINCE': this.pushCourierRate(12)
                    }
                } else if (key == 'SPXP') {
                    
                    if (new Date(this.inputCourier.effective_date) >= new Date('2022-11-01 00:00:00')) {
                        this.tableRate.courierRate = {
                            BKK_TO_BKK: this.pushCourierRate(1),
                            BKK_TO_UPC: this.pushCourierRate(2),
                            UPC_TO_BKK: this.pushCourierRate(3),
                            UPC_TO_UPC: this.pushCourierRate(4)
                        }
                    } else {
                        this.tableRate.courierRate = {
                            BKK: this.pushCourierRate(1),
                            UPC: this.pushCourierRate(2),
                        }
                    }
                } else if ( key == 'DHL' ) {
                    this.tableRate.courierRate = {
                        'BKK': this.pushCourierRate(1),
                        'C': this.pushCourierRate(2),
                        'UPC': this.pushCourierRate(3),
                    }
                } else if (key == 'JNT') {
                    const zones = COURIER.setCourier(key).getAvaliableZones()

                    const _this = this

                    const temp = Object.entries(zones).reduce((acc, [k, v]) => {
                        acc[k] = _this.pushCourierRate(v)

                        return acc
                    }, {})

                    this.tableRate.courierRate = { ...temp }
                } else {
                    this.tableRate.courierRate = {
                        BKK: this.pushCourierRate(1),
                        UPC: this.pushCourierRate(2)
                    }
                }
            } else if (!this.isEdit() && (this.isWho() == 'superadmin' || this.isWho() == 'shippop')) {
                if( key == 'BEE' ){
                    this.tableRate.courierRate = {
                        BKK: this.pushCourierRate(1),
                    }
                }else if( ['XPSO', 'XPSD'].includes(key) ){
                    this.tableRate.courierRate = {
                        GBKK_TO_GBKK: this.pushCourierRate(1)
                    }
                }else if( key == 'TPSD' ){
                    this.tableRate.courierRate = {
                        DEFAULT: this.pushCourierRate(1)
                    }
                } else if (key == 'SPXP') {
                    if (new Date(this.inputCourier.effective_date) >= new Date('2022-11-01 00:00:00')) {
                        this.tableRate.courierRate = {
                            BKK_TO_BKK: this.pushCourierRate(1),
                            BKK_TO_UPC: this.pushCourierRate(2),
                            UPC_TO_BKK: this.pushCourierRate(3),
                            UPC_TO_UPC: this.pushCourierRate(4)
                        }
                    } else {
                        this.tableRate.courierRate = {
                            BKK: this.pushCourierRate(1),
                            UPC: this.pushCourierRate(2),
                        }
                    }
                } else if (['EMSXP', 'TRUE'].includes(key)) {
                    this.tableRate.courierRate = {
                        BKK: this.pushCourierRate(1),
                        UPC: this.pushCourierRate(2)
                    }
                } else if ( key == 'DHL' ) {
                    this.tableRate.courierRate = {
                        'BKK': this.pushCourierRate(1),
                        'C': this.pushCourierRate(2),
                        'UPC': this.pushCourierRate(3),
                    }
                } else if (
                    ['KRYS', 'KRYQ'].includes(this.inputCourier.courierKey) && 
                    this.inputCourier.effective_date && 
                    new Date(this.inputCourier.effective_date).getTime() >= new Date('2023-09-05 00:00:00').getTime()
                ) {
                    this.tableRate.courierRate = {
                        SAME_PROVINCE: this.pushCourierRate(1),
                        WITHIN_1200KM: this.pushCourierRate(2),
                        MORE_THAN_1200KM: this.pushCourierRate(3)
                    }
                } else if (
                    this.inputCourier.effective_date && 
                    new Date(this.inputCourier.effective_date) >= new Date('2023-01-01 00:00:00') &&
                    ['MSE', 'MSEC', 'MSEF', 'SPE', 'SPEC'].includes(key)) {
                        console.log('push rate 2')
                    this.tableRate.courierRate = {
                        'BKK_GBKK_TO_BKK': this.pushCourierRate(1),
                        'BKK_GBKK_TO_GBKK': this.pushCourierRate(2)
                    }
                } else {
                    this.tableRate.courierRate = this.defaultCourierRate()
                }
            } else {
                this.tableRate.courierRate = this.tableRate.courierRate
            }
            // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
        }
    },
    watch: {
        'permission.samePage': function () {
            window.location.reload()
        },
        'inputCourier.effective_date': function() {
             this.updateCourierZone()
        },
        'inputCourier.courierKey': function () {
            this.updateCourierZone()
        },
        'inputCourier.selectCourierType': function () {
            this.updateCourierZone()
            this.validateData.submitted = false //reset validate ตอนเปลี่ยนค่า
            if (this.inputCourier.selectCourierType == 0 && !this.isEdit() && (this.isWho() == 'superadmin' || this.isWho() == 'shippop')) {
                this.inputCourier.courierKey = 'SPGEN'
                this.tableRate.courierRate = this.defaultCourierRate()
                this.permission.isGen = true
            } else if (!this.isEdit() && (this.isWho() == 'superadmin' || this.isWho() == 'shippop')) {
                this.inputCourier.courierKey = ''
                this.permission.isGen = false
            } else if (this.isEdit() && this.inputCourier.selectCourierType == 0 && this.inputCourier.courierKey == 'GEN') {
                this.permission.isGen = true
            } else {
                this.permission.isGen = false
            }
        },
        'inputCourier.adminSelectCourierType': function () {
            this.updateCourierZone()
            this.validateData.submitted = false //reset validate ตอนเปลี่ยนค่า
            if (this.inputCourier.adminSelectCourierType == 0 && this.isWho() == 'admin') {
                this.inputCourier.btnTitle = ""
                this.inputCourier.descriptionCouier = ""
                this.inputCourier.courierKey = "GEN"
                this.inputCourier.selectCourier = ""
                this.inputCourier.courierName = ""
                
                this.tableRate.courierRate = this.defaultCourierRate()
                this.permission.isGen = true
            } else if (!this.isEdit()) {
                this.inputCourier.btnTitle = ""
                this.inputCourier.descriptionCouier = ""
                this.inputCourier.courierKey = ""
                this.inputCourier.selectCourier = ""
                this.inputCourier.courierName = ""
                this.inputCourier.adminSelectCourierType = 1
                this.tableRate.courierRate = this.defaultCourierRate()
                this.permission.isGen = false
            }
            if (['admin', 'member'].includes(this.isWho())) {
                this.permission.table.min.disabled = true
                if (!this.permission.isGen) {
                    this.permission.table.max.disabled = true
                } else {
                    this.permission.table.max.disabled = false
                }
                this.permission.table.rate.disabled = true
                this.permission.table.dimension.disabled = true
            }
        }
    }
}
</script>
